import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createServerIcon(options: NodeIconOptions = {}): string {
  const opts = {
    ...nodeIconDefaultOptions,
    ...options,
  };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path
      d="M6.5 32V26.45H33.5V32H6.5ZM8.75 30.575H11.45V27.875H8.75V30.575ZM6.5 13.55V8H33.5V13.55H6.5ZM8.75 12.125H11.45V9.425H8.75V12.125ZM6.5 22.775V17.225H33.5V22.775H6.5ZM8.75 21.35H11.45V18.65H8.75V21.35Z"
      fill="${ICON_DEFAULT_FOREGROUND_COLOR}"
    />
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const serverIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createServerIcon,
);
